// extracted by mini-css-extract-plugin
export var circle = "_bv-1";
export var exitConfirmationModal = "_bv-5";
export var iframe = "_bv-0";
export var offline = "_bv-3";
export var online = "_bv-2";
export var workstationSelectError = "_bv-4";